// Cant use this because of CI build being built with prod as the env

// export const getEnv = () => {
//    return process.env.NODE_ENV;
// };

export const getEnv = () => {
  const hostnameParts = window.location.hostname.split(".");
  return hostnameParts.length > 2
    ? hostnameParts[hostnameParts.length - 3]
    : "";
};

export const getLowerEnv = () => {
  const hostnameParts = window.location.hostname.split(".rockloans.com");
  return hostnameParts[0];
};

export const isProd = () => {
  const env = getEnv();
  return env === "www" || env === "prod" || env === "production";
};

export const isDev = () => {
  const env = getEnv();
  return env === "dev";
};

export const getBaseURL = () => window.location.host.replace(/^www\./, "");
